import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ModalConfirmComponent, ModalOptions } from './modal-confirm.component'

@Injectable({
  providedIn: 'root'
})
export class ModalConfirmService {

  constructor(private readonly dialog: MatDialog) { }

  async confirm(options: ModalOptions, matDialogConfig?: MatDialogConfig<ModalOptions>){
    matDialogConfig = matDialogConfig ?? { hasBackdrop: true }
    matDialogConfig.data = options
    const dialogRef = this.dialog.open(ModalConfirmComponent, matDialogConfig);
    return await dialogRef.afterClosed().toPromise()
  }
}
